import { render, staticRenderFns } from "./StudentSchedule.vue?vue&type=template&id=4463cdbe"
import script from "./StudentSchedule.vue?vue&type=script&lang=js"
export * from "./StudentSchedule.vue?vue&type=script&lang=js"
import style0 from "./StudentSchedule.vue?vue&type=style&index=0&id=4463cdbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports